module.exports = __webpack_public_path__ + "static/img/energy-h5-2.f46f46b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/energy-h5-2.png
// module id = 6ZLs
// module chunks = 34